export default "__VITE_ASSET__BNGZRHOh__"